import React, { useState, useMemo } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Widget,
  Table,
  ColumnProps,
} from '@digital/ui';


import { compareNumber, compareDates, compareTypeNumber } from '@app/helpers/comparators';
import { mountFormFilterDropDown } from '@app/components/FormFilterDropDown';
import { GetAllCrfPlanilhaRfaAnoMes } from '@app/api/crf/crfProjeto';

interface PlanilhaCapexTabelaProps {
  atualizarTelaProp: boolean;
  projeto: any;
  hasPlanilha(planilha: boolean): void;
}

const CrfPlanilhaRfaTabela = (props: PlanilhaCapexTabelaProps) => {
  const { atualizarTelaProp, projeto, hasPlanilha } = props;
  const [colunasTabelaResult, setColunasTabela] = useState<ColumnProps<any>[]>();
  const [resultPlanilhaCapex, setResultPlanilhaCapex] = useState();

  const getAllOrdemInvestimento = useMemo(async () => {
    if (projeto) {
      const result: any = await GetAllCrfPlanilhaRfaAnoMes(projeto.id);
      if (result) {
        if (result.nomeColunasDinamicas) {
          const colunaNome = result.nomeColunasDinamicas as string[];
          setColunasTabela(result.columnProps);
          setResultPlanilhaCapex(result.tabelaPlanilhaCapexOrcado);
          if (colunaNome) {
            if (colunaNome.length > 0) {
              hasPlanilhaRfa(true);
            } else {
              hasPlanilhaRfa(false);
            }
          }
        }
      }
    }
  }, [projeto, atualizarTelaProp]);

  const hasPlanilhaRfa = async (tem: boolean) => {
    const result = await hasPlanilha(tem, projeto);
  };

  const colunasTabela = useMemo(() => {
    const actions = [];
    actions.push(
      {
        title: 'Centro de Custo',
        dataIndex: 'numeroCentroDeCusto',
        width: '3%',
        ...mountFormFilterDropDown("numeroCentroDeCusto", "Pesquisar por centro de custo"),
        sorter: (a: any, b: any) => compareNumber(a.numeroCentroDeCusto, b.numeroCentroDeCusto),
      },
      {
        title: 'Conta Contábil',
        dataIndex: 'crfContaContabilCodigo',
        width: '3%',
        ...mountFormFilterDropDown("crfContaContabilCodigo", "Pesquisar por conta contábil"),
        sorter: (a: any, b: any) => compareNumber(a.crfContaContabilCodigo, b.crfContaContabilCodigo),
      },
      {
        title: 'Número',
        dataIndex: 'numero',
        width: '3%',
        ...mountFormFilterDropDown("numero", "Pesquisar por número"),
        sorter: (a: any, b: any) => compareTypeNumber(a.numero, b.numero),
      },
      {
        title: 'Revisão',
        dataIndex: 'revisao',
        width: '3%',
        ...mountFormFilterDropDown("revisao", "Pesquisar por revisão"),
        sorter: (a: any, b: any) => compareTypeNumber(a.revisao, b.revisao),
      },
      {
        title: 'Data de Aprovação',
        dataIndex: 'dataAprovacao',
        width: '5%',
        sorter: (a: any, b: any) => compareDates(a.dataAprovacao, b.dataAprovacao),
        ...mountFormFilterDropDown("dataAprovacao", "Pesquisar por data de aprovação"),
      },
    );

    if (colunasTabelaResult) {
      colunasTabelaResult.map(coluna => {
        actions.push({
          title: coluna.title,
          dataIndex: coluna.dataIndex,
          key: coluna.dataIndex,
          width: coluna.width,
        });
      });
    }

    return actions;
  }, [colunasTabelaResult, atualizarTelaProp]);

  return (
    <Widget title="Orçado RFA">
      <PerfectScrollbar>
        <Table
          className="multiple-level-table tabelas-orcado-crf"
          columns={colunasTabela}
          dataSource={resultPlanilhaCapex}
          pagination={false}
        />
      </PerfectScrollbar>
    </Widget>
  );
};

export default CrfPlanilhaRfaTabela;
